import React, { useCallback } from 'react';
import { StackActions, useNavigation } from '@react-navigation/native';

import { useOfflineQueue } from '../../offline';
import TrainingModeBanner from '../myDay/TrainingModeBanner';
import { useDriverShell } from './DriverDayProvider';
import { DRIVER_ROUTE } from './driverRoutes';

/**
 * Training mode banner for redesigned screens (pass it as Screen `banner`).
 * Renders nothing outside training. "Back to employee preview" turns training
 * off and returns to the preview (reopening it for the same employee when it
 * was closed); "Choose employee" turns it off and opens the employee list.
 */
const DriverTrainingBanner = () => {
	const navigation = useNavigation();
	const { isOnline } = useOfflineQueue();
	const { trainingContext, exitTraining, openEmployeeSelector } = useDriverShell();

	const backToPreview = useCallback(() => {
		const employee = trainingContext?.employee;
		exitTraining();
		const hasPreview = navigation.getState()?.routes?.some(route => route.name === DRIVER_ROUTE.EMPLOYEE_DAY_PREVIEW);
		if (hasPreview) {
			// Merge keeps the preview's employee param (popTo replaces params otherwise).
			navigation.dispatch(StackActions.popTo(DRIVER_ROUTE.EMPLOYEE_DAY_PREVIEW, undefined, { merge: true }));
			return;
		}
		if (navigation.canGoBack()) {
			navigation.dispatch(StackActions.popToTop());
		}
		// The preview was closed (e.g. Home tab): open it again for the same employee.
		if (employee) {
			navigation.navigate(DRIVER_ROUTE.EMPLOYEE_DAY_PREVIEW, { employee });
		}
	}, [exitTraining, navigation, trainingContext?.employee]);
	const chooseEmployee = useCallback(() => {
		exitTraining();
		openEmployeeSelector();
	}, [exitTraining, openEmployeeSelector]);

	if (!trainingContext) {
		return null;
	}

	return (
		<TrainingModeBanner
			trainingContext={trainingContext}
			isOnline={isOnline}
			onBack={backToPreview}
			onChooseEmployee={chooseEmployee}
		/>
	);
};

export default DriverTrainingBanner;
